export const getApiUrl = (path, params) => {
  // eslint-disable-next-line no-param-reassign
  let p = params || {};
  p = `?${Object.keys(p).map((key) => `${key}=${p[key]}`).join('&')}`;

  if (p === '?') {
    p = '';
  }

  if (path.includes('http://') || path.includes('https://') || path.startsWith('/api')) {
    // In case the passed url is a full url;
    return `${path}${p}`;
  }
  return `/api/${path}${p}`;
};


export const getBackendUrl = (url) => {
  if (url.includes('http://') || url.includes('https://')) {
    // In case the passed url is a full url;
    return url;
  }

  let path;
  if (url.startsWith('/')) {
    path = url.substring(1);
  } else {
    path = url;
  }
  return `/${path}`;
};
